import React from "react";
import ReactDOM from "react-dom";
import { Router, Route, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import Web3 from "web3";
import { Web3ReactProvider } from "@web3-react/core";

import Vesting from "./vesting";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

var hist = createBrowserHistory();
const rootElement = document.getElementById("root");

function getLibrary(provider) {
  return new Web3(provider);
}

ReactDOM.render(
  <Web3ReactProvider getLibrary={getLibrary}>
    <Router history={hist}>
      <Switch>
        <Route path="/" component={Vesting} />
      </Switch>
    </Router>
  </Web3ReactProvider>,
  rootElement
);
